// i18next-extract-mark-ns-start leatherGoodsServices
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import HeaderBanner from '../../HeaderBanner';
import Intro from '../../Intro';
import WorksBanner from '../../WorksBanner';
import OurRanges from './OurRanges';
import HowItWorksBlock from '../HowItWorksBlock';
import AllServices from './AllServices';
import TipsServices from './TipsServices';
import SpecialRequest from './SpecialRequest';
import withAppContext from '../../../withAppContext';

// assets
import MaroBanner from '../../../assets/ourServices/leatherGoods/maro.banner.jpg';
import entretien from '../../../assets/ourServices/leatherGoods/entretien.svg';
import recoloration from '../../../assets/ourServices/leatherGoods/recoloration.svg';
import réparation from '../../../assets/ourServices/leatherGoods/reparation.maro.svg';

import ceinture from '../../../assets/ourServices/leatherGoods/ceinture.range.jpg';
import sac from '../../../assets/ourServices/leatherGoods/sac.range.jpg';
import petiteMaro from '../../../assets/ourServices/leatherGoods/petiteMaro.range.jpg';
import sacCuir from '../../../json/images/laRubrique/v3/reparerUnSacEnCuir.1.jpg';
import zipSac from '../../../json/images/laRubrique/v3/commentReparerLaFermetureEclairDUnSac.1.jpg';
import demandeMaro from '../../../assets/ourServices/demande.maro.jpg';
import demandeMaroMobile from '../../../assets/ourServices/demande.maro.mobile.jpg';

const getLeatherGoodsDatas = (t) => [
  {
    icon: entretien,
    title: t('Nettoyage et Entretien'),
    text: t('Sac en cuir, sac en daim, ceinture'),
  },
  {
    icon: réparation,
    title: t('Réparations'),
    text: t('Sac en cuir, sac en daim, ceinture'),
  },
  {
    icon: recoloration,
    title: t('Teinture et Recoloration'),
    text: t('Sac en cuir, sac en daim, ceinture'),
  },
];

const getCouturierRanges = (t) => [
  {
    image: ceinture,
    title: t('Ceinture \ncuir et daim'),
    key: 'belt',
  },
  {
    image: sac,
    title: t('Sac \ncuir et daim'),
    key: 'bag',
  },
  {
    image: petiteMaro,
    title: t('Portefeuille \ncuir et daim'),
    key: 'smallLeatherGoods',
  },
];

export const getLeatherGoodsArticles = (t) => [
  {
    image: sacCuir,
    title: t('Réparer un sac en cuir'),
    text: t(
      // eslint-disable-next-line max-len
      'Vous le savez, le cuir est une matière vivante qui se fragilise avec le temps et qui nécessite un entretien régulier. Cependant, à force d’usure ou d’accident, il arrive parfois qu’il s’abîme, se déchire, voire même se craque. Rassurez-vous, sauf cas exceptionnel, il est possible de réparer le cuir. Et on vous explique comment !',
    ),
    link: t('/la-rubrique/reparer-un-sac-en-cuir/'),
  },
  {
    image: zipSac,
    title: t('Réparer le zip'),
    text: t(
      // eslint-disable-next-line max-len
      'La fermeture éclair de votre sac est cassée et il ne ferme plus ! Vous avez bien essayé de la remplacer par une ou deux épingles à nourrices mais franchement, le look n‘y est plus. Tilli vous explique comment réparer facilement la fermeture éclair de votre sac adoré ou au pire des cas, comment la changer !',
    ),
    link: t('/la-rubrique/comment-reparer-la-fermeture-eclair-d-un-sac/'),
  },
];

function LeatherGoodsServices({ context: { isMobile } }) {
  const { t } = useTranslation();
  return (
    <>
      <HeaderBanner
        image={MaroBanner}
        title={t('Un artisan maroquinier pour\n nettoyer et réparer vos sacs en cuir')}
        text={t(
          'Nos artisans maroquiniers vous accompagnent à entretenir, réparer, sublimer ou même réinventer vos sacs et accessoires en cuir !',
        )}
        preFilledSteps={{ selectedCategory: 'accessories' }}
      />
      <Intro work="leatherGoods" title={t('Un maroquinier à proximité et en ligne')} />
      <WorksBanner works={getLeatherGoodsDatas(t)} />
      <OurRanges
        ranges={getCouturierRanges(t)}
        preSelectedRange="bag"
        title={t('Types d‘accessoires')}
        subtitle={t('Les types d‘accessoires que nos artisans réparent et nettoient')}
      />
      <HowItWorksBlock isPackage />
      <AllServices />
      <TipsServices articles={getLeatherGoodsArticles(t)} />
      <SpecialRequest background={isMobile ? demandeMaroMobile : demandeMaro} />
    </>
  );
}

LeatherGoodsServices.propTypes = {
  context: PropTypes.shape({
    isMobile: PropTypes.bool,
  }).isRequired,
};

export default withAppContext(LeatherGoodsServices);
